import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const FAQ_DATA = [
  {
    id: "1",
    number: "01",
    category: "Formulation",
    question: "Are all Glow products 100% organic and cruelty-free?",
    answer:
      "Yes, every formula is 100% vegan, cruelty-free, and ethically sourced using certified organic botanical extracts with zero parabens, sulfates, or synthetic fragrance.",
  },
  {
    id: "2",
    number: "02",
    category: "Results",
    question: "How long does it take to see visible skin improvements?",
    answer:
      "Most users notice enhanced hydration and natural radiance within the first 7 to 14 days. Texture, elasticity, and firmness improvements typically show within 30 days of consistent daily application.",
  },
  {
    id: "3",
    number: "03",
    category: "Skin Type",
    question: "Which products are best suited for sensitive skin?",
    answer:
      "Our Deep Hydration Serum and Soothing Cleansing Balm are specially formulated with active chamomile, oat lipids, and squalane to calm inflammation and support hyper-sensitive skin barriers.",
  },
  {
    id: "4",
    number: "04",
    category: "Shipping & Returns",
    question: "What is your shipping and return guarantee policy?",
    answer:
      "We offer free global carbon-neutral shipping on orders over $50. If you are not completely satisfied with your routine, return any item within 30 days for a full hassle-free refund.",
  },
  {
    id: "5",
    number: "05",
    category: "Routine",
    question: "Can I layer Glow serums with my existing retinol routine?",
    answer:
      "Optionally yes! Our botanical serums are engineered to complement active dermatological ingredients. Apply our hydrating layer first, wait 5 minutes to absorb, then follow with your evening retinol treatment.",
  },
];

export default function FaqNatural({ className }) {
  const [openId, setOpenId] = useState("1");

  const toggleFAQ = (id) => {
    setOpenId((prev) => (prev === id ? "" : id));
  };

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Big+Shoulders+Display:wght@600;700&family=Inter:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />

      <section
        className={
          "w-full bg-[#EDE7E0] text-[#000] antialiased py-12 sm:py-16 md:py-24 px-4 sm:px-8 lg:px-12 flex flex-col items-center select-none overflow-hidden " +
          (className || "")
        }
      >
        <div className="w-full max-w-[1170px] mx-auto flex flex-col gap-10 md:gap-14">
          <div className="w-full flex flex-col items-center text-center gap-3 sm:gap-4">
            <h2
              className="tracking-tighter select-none block text-center"
              style={{
                fontFamily: '"Big Shoulders Display", sans-serif',
                fontSize: "clamp(40px, 7.5vw, 110px)",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "0.95",
                letterSpacing: "-2.5px",
                margin: 0,
              }}
            >
              <span style={{ color: "#000000" }}>Frequently </span>
              <span style={{ color: "#B5B3AC" }}>Asked </span>
              <span style={{ color: "#000000" }}>Questions</span>
            </h2>

            <div className="w-full flex justify-center pt-1">
              <p
                style={{
                  color: "#353535",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "clamp(15px, 1.3vw, 20px)",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "1.45",
                  maxWidth: "780px",
                  textAlign: "center",
                  margin: "0 auto",
                }}
              >
                Everything you need to know about our organic skincare formulations, shipping policies, and daily application routines.
              </p>
            </div>
          </div>

          <div className="w-full flex flex-col gap-4 sm:gap-6 pt-4">
            {FAQ_DATA.map((item) => {
              const isOpen = openId === item.id;

              return (
                <div
                  key={item.id}
                  className="w-full transition-all duration-300 rounded-[16px] sm:rounded-[20px] overflow-hidden"
                  style={{
                    background: "#FFFFFF",
                    boxShadow: "none",
                    border: isOpen ? "1px solid #DCD6CD" : "1px solid #E6E0D8",
                  }}
                >
                  <button
                    onClick={() => toggleFAQ(item.id)}
                    className="w-full p-[25px] flex items-center justify-between gap-4 text-left cursor-pointer group"
                    aria-expanded={isOpen}
                  >
                    <div className="flex items-center gap-4 sm:gap-8 min-w-0">
                      <span
                        style={{
                          fontFamily: '"Big Shoulders Display", sans-serif',
                          fontSize: "40px",
                          fontWeight: 700,
                          lineHeight: "1",
                          color: isOpen ? "#CBEC79" : "#9E9E9E",
                          letterSpacing: "-1px",
                        }}
                        className="shrink-0 transition-colors duration-300"
                      >
                        {item.number}
                      </span>

                      <h3
                        style={{
                          color: "#242121",
                          fontFamily: '"Big Shoulders Display", sans-serif',
                          fontSize: "36px",
                          fontStyle: "normal",
                          fontWeight: 600,
                          lineHeight: "1.1",
                          letterSpacing: "-0.8px",
                          margin: 0,
                        }}
                        className="transition-colors duration-200"
                      >
                        {item.question}
                      </h3>
                    </div>

                    <div
                      className="w-[40px] h-[40px] shrink-0 rounded-full flex items-center justify-center transition-all duration-300"
                      style={{
                        background: isOpen ? "#CBEC79" : "#DCDCDC",
                        color: "#242121",
                        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2.5}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        {isOpen ? (
                          <line x1="5" y1="12" x2="19" y2="12" />
                        ) : (
                          <>
                            <line x1="12" y1="5" x2="12" y2="19" />
                            <line x1="5" y1="12" x2="19" y2="12" />
                          </>
                        )}
                      </svg>
                    </div>
                  </button>

                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        key={item.id + "-body"}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                      >
                        <div className="px-5 sm:px-7 md:px-8 pb-6 sm:pb-8 pt-0 pl-14 sm:pl-20 md:pl-24 pr-6 sm:pr-12">
                          <p
                            style={{
                              color: "#4B4B4B",
                              fontFamily: "Inter, sans-serif",
                              fontSize: "clamp(15px, 1.25vw, 19px)",
                              fontStyle: "normal",
                              fontWeight: 500,
                              lineHeight: "1.6",
                              maxWidth: "900px",
                              margin: 0,
                            }}
                          >
                            {item.answer}
                          </p>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}